export default function getCellStyle(column, style = {}) {
	if (column.onClick) {
		style.cursor = "pointer";
	}

	if (column.noWrap) {
		style.whiteSpace = "nowrap";
	}

	if (column.sticky) {
		style = {
			...style,
			position: "sticky",
			right: 0,
			left: 0,
			backgroundColor: "var(--color-bg-card)",
			zIndex: 999,
			borderRight: column.totalLeft === 0 ? "1px solid var(--color-border)" : "none",
			borderLeft: column.totalLeft !== 0 ? "1px solid var(--color-border)" : "none",
		};
	}

	return style;
}
